import React, { useState, FC, MouseEvent } from "react";

import { QueryObserverResult } from "@tanstack/react-query";
import { toast } from "react-toastify";

import {
  useEditorState,
  useApisMembersKnowledgeInsightPostsKnowledgeInsightPostCommentsCreate,
  useEditorStateLinkContentGetter,
} from "~/hooks";

import {
  KnowledgeInsightPostCommentDetailWithEditForm,
  KnowledgeInsightPostDetail,
  TextEditor,
} from "~/components/organisms";

import {
  AvatarAndNameEmployeeType,
  KnowledgeInsightPostType,
  KnowledgeInsightPostCommentType,
  PreviewWithFileType,
  ApiMemberKnowledgeInsightPostKnowledgeInsightPostCommentsIndexType,
} from "~/domains";

type PropsType = {
  refetch: () => Promise<
    QueryObserverResult<
      ApiMemberKnowledgeInsightPostKnowledgeInsightPostCommentsIndexType,
      unknown
    >
  >;
  mentions: AvatarAndNameEmployeeType[];
  knowledgeInsightPost: KnowledgeInsightPostType;
  knowledgeInsightPostComments: KnowledgeInsightPostCommentType[];
  className?: string;
  highlightKnowledgeInsightPostCommentId?: string;
};

export const KnowledgeInsightPostCommentsWithKnowledgeInsightPost: FC<
  PropsType
> = ({
  refetch,
  mentions,
  knowledgeInsightPost,
  knowledgeInsightPostComments,
  className = "",
  highlightKnowledgeInsightPostCommentId,
}: PropsType) => {
  const [files, setFiles] = useState<PreviewWithFileType[]>([]);
  const [
    {
      value: editorState,
      onChange: setEditorState,
      jsonContent,
      hasText,
      setPlainText,
    },
  ] = useEditorState();
  const { fetchedData } = useEditorStateLinkContentGetter({
    watchEditorState: editorState,
    isWatch: true,
  });

  const { mutate, isLoading } =
    useApisMembersKnowledgeInsightPostsKnowledgeInsightPostCommentsCreate();

  const handleSubmit = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!hasText) {
      toast.error("テキストが空です");
      return;
    }
    const body = {
      content: jsonContent,
      attachFiles: files,
      quotePostId: fetchedData?.id,
    };

    mutate(
      {
        knowledgeInsightPostId: knowledgeInsightPost.id,
        body,
      },
      {
        onSuccess: async () => {
          setPlainText("");
          setFiles([]);
          await refetch();
        },
      },
    );
  };
  return (
    <div className={className}>
      <div className="space-y-6">
        <KnowledgeInsightPostDetail
          knowledgeInsightPost={knowledgeInsightPost}
          menuItems={[]}
          openComment={refetch}
        />
        <div>
          {knowledgeInsightPostComments.map((comment) => (
            <KnowledgeInsightPostCommentDetailWithEditForm
              key={comment.id}
              knowledgeInsightPostComment={comment}
              mentions={mentions}
              refetch={refetch}
              isHighlight={
                highlightKnowledgeInsightPostCommentId === comment.id
              }
            />
          ))}
        </div>
        <TextEditor
          submitButton={{
            isSubmitting: isLoading,
            onSubmit: handleSubmit,
          }}
          mentions={mentions}
          editorState={editorState}
          setEditorState={setEditorState}
          files={files}
          onChangeFiles={setFiles}
          blockQuote={fetchedData}
          isEmojiPickerTop
        />
      </div>
    </div>
  );
};
